import { nanpPhonePattern } from "@homeinstead/locale";
import { z } from "zod";

export const phone = z
  .string()
  .min(1, { error: "Phone Number is required" })
  .regex(nanpPhonePattern, {
    error: "Phone number must be a valid US or Canadian number",
  });
